import React from 'react'

const React_Assignment_1 = () => {
  return (
    <div>
      <h1>Assignment 1</h1>
    </div>
  )
}

export default React_Assignment_1
